import React from 'react';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import { PolicyPage } from '../styles/policyStyles';
import { useLanguage } from '../context/LanguageContext';
import PrivacyEn from '../content/legal/PrivacyEn';
import PrivacyZh from '../content/legal/PrivacyZh';

function PrivacyPage() {
  const { language } = useLanguage();
  const Content = language === 'zh' ? PrivacyZh : PrivacyEn;

  return (
    <>
      <SiteHeader />
      <PolicyPage>
        <Content />
      </PolicyPage>
      <SiteFooter />
    </>
  );
}

export default PrivacyPage;
